import styled from 'styled-components';

export const StyledDiv = styled.div`
  margin-right: var(--space-4);
`;

export const StyledParagraph = styled.p`
  margin-bottom: var(--space-4);
`;
